// removed by extract-text-webpack-plugin
module.exports = {"contact":"_1wJDpeGObpmwuNct8mY62t","lineBreak":"_2jGvGpcqdKArSN-FdLW8OY","email":"_2ezaaEUgj8XTAr7tdbWQnM","link":"_1G4iTIRr725GwGigCKovZz","social":"_1IcswdG687WeTaMJRjeAEA"};


//////////////////
// WEBPACK FOOTER
// ./contact/styles.module.css
// module id = 462
// module chunks = 0